import type { QueryRunner } from 'typeorm';

/**
 * Migrations run under a storefront-specific Postgres owner role (e.g. WT's
 * `r_wt_headless_storefront_owner`). The schema is shared; the role is not —
 * each storefront provides it via `DB_MIGRATIONS_ROLE` ("execution stays on
 * storefront level"). Pair with a `RESET ROLE` in a finally block.
 */
export const setMigrationRole = async (queryRunner: QueryRunner): Promise<void> => {
  const role = process.env.DB_MIGRATIONS_ROLE;
  if (!role) {
    throw new Error(
      'DB_MIGRATIONS_ROLE env var is required to run @ecom/storefront-auth-db migrations',
    );
  }
  await queryRunner.query(`SET ROLE "${role}"`);
};
